<template>
  <el-card class="page_card" ref="card" v-loading="!is_ok">
    <!-- #84efb4 -->
    <el-row :gutter="20" style="margin-bottom: 10px">
      <el-col :span="4">
        <div class="grid-content bg-purple">
          <el-button type="primary" plain @click="currentPlanBtn"
            >当前计划 {{ this.currentPlanNum }}</el-button
          >
        </div>
      </el-col>
      <el-col :span="5">
        <div class="grid-content bg-purple">
          <el-button type="success" plain @click="pendApprovedPlanBtn"
            >待审批计划 {{ this.pendApprovedPlanNum }}</el-button
          >
        </div>
      </el-col>
      <el-col :span="5">
        <div class="grid-content bg-purple">
          <el-button type="info" plain @click="approvedPlanBtn"
            >已审批计划 {{ this.approvedPlanNum }}</el-button
          >
        </div>
      </el-col>
      <el-col :span="5">
        <div class="grid-content bg-purple">
          <el-button type="warning" plain @click="changePlanBtn"
            >变更计划 {{ this.changePlanNum }}</el-button
          >
        </div>
      </el-col>
      <el-col :span="5" style="margin-top: 8px" v-can="['btn:sales_audit']">
        <el-radio-group v-model="activeAudit" @change="switch_exm">
          <el-radio :label="true">销售审核</el-radio>
          <el-radio :label="false">自动审核</el-radio>
        </el-radio-group>
        <!-- <el-switch
          @change="switch_exm($event)"
          v-model="activeAudit"
          active-color="#13ce66"
          inactive-color="#ff4949"
        ></el-switch> -->
      </el-col>
    </el-row> 

    <el-form :model="selectForm" ref="selectForm" inline>
        <el-form-item>
          <span style="font-weight:bold;">共{{total}}条</span>
        </el-form-item>
        <el-form-item label="企业名称或简称">
          <el-select style="width:200px"
            v-model="selectForm.comId"
            :multiple="false"
            filterable
            remote
            reserve-keyword
            placeholder="请输入企业名称或简称"
            :loading="is_select"
            @change="changeCom"
          >
            <el-option
              v-for="item in componys"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主车号">
          <el-input style="width:150px"
            v-model="selectForm.plateNumber"
            placeholder="请输入主车号"
          ></el-input>
        </el-form-item>
        <el-form-item label="驾驶员">
          <el-input style="width:150px"
            v-model="selectForm.driverName"
            placeholder="请输入驾驶员"
          ></el-input>
        </el-form-item>
        <el-form-item label="驾驶员电话">
          <el-input style="width:150px"
            v-model="selectForm.driverMobile"
            placeholder="请输入驾驶员电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="日期">
          <el-select v-model="selectForm.planDate" placeholder="请选择">
              <el-option label="全部" value="0"></el-option>
              <el-option label="今天" value="1"></el-option>
              <el-option label="明天" value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="计划单状态">
            <el-select v-model="selectForm.newStatus" placeholder="请选择">
                <el-option v-for="(item,index) in statuType" :key="index" :label="item.lb" :value="item.vl"></el-option>
            </el-select>
        </el-form-item> -->
        <el-form-item label="计划单状态">
            <el-select v-model="selectForm.status" multiple collapse-tags placeholder="请选择" filterable ref="selectForm_status" >
                <el-option
                    :disabled="selectForm.status.includes(-1) && item.value == -1"
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="">
          <el-button
            plain
            type="primary"
            @click="selectSubmit()"
            :loading="is_post"
            >查 询</el-button
          >
          <el-button plain @click="resetSelect()" :loading="is_post"
            >重 置</el-button
          >
        </el-form-item>
        <el-form-item label="">
          <el-button
            type="success"
            @click="goToAdd"
            v-can="['btn:add_plan']"
          >
            + 新增计划单</el-button
          >
          <el-button
            type="warning"
            plain
            @click="changePrice"
            v-show="activeName == 'first'"
            v-can="['btn:change_price']"
            ><svg-icon icon-class="price" /> 调价({{
              itemCheck.length
            }})</el-button
          >
          <el-button
            type="warning"
            plain
            icon="el-icon-download"
            v-can="['btn:add_plan']"
            @click="downloadExcel"
            >下载计划单模板</el-button
          >
          <el-button type="success" @click="batchApproval" v-can="['btn:project_approval']" :disabled="is_batch_pass"
            >批量审批</el-button
          >
          <el-button type="warning" @click="batchRejected" v-can="['btn:rejection_plan']" :disabled="is_batch_reject">批量驳回</el-button>
          <el-button type="warning" @click="showEditPlanDate" v-can="['btn:rejection_plan']" :disabled="is_batch_reject">批量修改计划时间</el-button>
          <el-button type="warning" plain :icon="uploadBtnIcon" @click="clickUpload" v-can="['btn:add_plan']">导入计划单</el-button>
          <el-button type="warning" plain :icon="el-icon-download" @click="downloadCurrExcel" v-can="['btn:export_curr_order']">导出计划</el-button>
        </el-form-item>
      </el-form>
     
      <el-dialog title="调价" :visible.sync="is_price" width="25%">
        <el-form
          :model="priceForm"
          ref="priceForm"
          :rules="priceRules"
          label-width="120px"
          inline
        >
          <el-form-item
            label="调价(元/吨)"
            prop="realPrice"
            style="width: 100%"
          >
            <el-input
              v-model="priceForm.realPrice"
              placeholder="请输入调价价格"
            ></el-input>
          </el-form-item>

          <el-form-item style="width: 100%; text-align: center">
            <el-button
              plain
              type="primary"
              :loading="is_post"
              @click="submitPriceChange"
              >确认调价</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 导出当前计划 -->
    <el-dialog title="导出计划单" :visible.sync="exportCurrDialog" width="30%">
      <el-form :model="uploadForm" ref="uploadForm" label-width="120px">
        <el-form-item label="计划日期" prop="planDate">
            <el-select v-model="uploadForm.planDate" placeholder="请选择计划日期" style="width:100%">
                <el-option
                    v-for="item in dates"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item style="margin-top:25px;">
          <el-button type="primary" ref="updataButt" plain :icon="uploadBtnIcon" @click="exportCurrSubmit">导出计划单</el-button >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="导入计划单" :visible.sync="uploadDialog" width="30%">
      <el-form :model="uploadForm" ref="uploadForm" label-width="120px">
        <el-form-item label="计划日期" prop="planDate">
            <el-select v-model="uploadForm.planDate" placeholder="请选择计划日期" style="width:100%">
                <el-option
                    v-for="item in dates"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item style="margin-top:25px;">
          <el-button type="primary" ref="updataButt" plain :icon="uploadBtnIcon" @click="clickSubmit">导入计划单</el-button >
          <el-upload
                  multiple
                  ref="upload"
                  v-loading="uploadLoading"
                  :show-file-list="false"
                  accept=".xls,.xlsx"
                  :limit="limitNum"
                  action="baseUrl"
                  :before-upload="beforeAvatarUploadPDF"
                  :http-request="uploadFile"
                  :on-success="fileUploadSuccess"
                  :on-error="fileUploadError"
                  :disabled="fileUploadBtnText == '正在导入'"
                  style="display: inline; margin-left: 10px"
          >
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog>
      <!-- 原来的 -->
    <!-- <el-form inline :model="selectForm" ref="selectForm">
        <el-form-item label="企业名称或简称">
            <el-select
                v-model="selectForm.comId"
                :multiple="false"
                filterable
                remote
                reserve-keyword
                placeholder="请输入企业名称或简称"
                :loading="is_select">
                <el-option
                    v-for="item in componys"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="计划编号">
            <el-input v-model="selectForm.orderSn" placeholder="请输入计划编号"></el-input>
        </el-form-item>
        <el-form-item label="主车号">
            <el-input v-model="selectForm.plateNumber" placeholder="请输入主车号"></el-input>
        </el-form-item>
        <el-form-item label="计划日期">
            <el-select v-model="selectForm.planDate" placeholder="请选择">
                <el-option label="全部" value="0"></el-option>
                <el-option label="今天" value="1"></el-option>
                <el-option label="明天" value="2"></el-option>
            </el-select>

        </el-form-item>
        <el-form-item label="状态">
            <el-select v-model="selectForm.status"
                        multiple
                        collapse-tags
                        placeholder="请选择"
                        filterable
                        ref="selectForm_status"
                        @change="statusChange">
                <el-option
                    :disabled="selectForm.status.includes(-1) && item.value == -1"
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="">
            <el-button plain type="primary" @click="selectSubmit()">查 询</el-button>
            <el-button plain @click="resetSelect()">重 置</el-button>
        </el-form-item>
    </el-form> -->

    <el-table
      ref="table"
      :data="data"
      class="history_table"
      v-if="showtable"
      @select="selectHandle"
      @selection-change="handleSelectionChange"
      v-loading="is_loading"
      :row-style='changebg'
      :row-class-name="tableRowClassName"
      :min-height="tableMinHeight"
      tooltip-effect="dark"
      :default-sort = "{prop: 'createTime', order: 'descending'}"
    >
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>
      <el-table-column label="计划编号" width="180" v-if="colOptions.orderSn">
        <template slot-scope="scope">
          <el-link
            :underline="false"
            @click="goToDetail(scope.row)"
            type="primary"
            >{{ scope.row.orderSn }}</el-link
          >
        </template>
      </el-table-column>
      <el-table-column label="企业名称" width="200" v-if="colOptions.comName">
        <template slot-scope="scope">
          <span class="primary_text">{{ scope.row.comName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="产品" width="70" v-if="colOptions.goodsName">
        <template slot-scope="scope">
          <span class="success_text">{{ scope.row.goodsName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="计划日期" width="120" v-if="colOptions.planDate">
        <template slot-scope="scope">
          {{ scope.row.planDate }}
        </template>
      </el-table-column>
      <el-table-column label="计划单状态" width="100" v-if="colOptions.status">
        <template slot-scope="scope">
          <el-tag :type="statusType(scope.row.status)">{{
            parseStatus(scope.row.status)
          }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="挂牌价" width="120" v-if="colOptions.realPrice">
        <template slot-scope="scope">
          <span class="warning_text">{{ scope.row.realPrice }} 元/吨</span>
        </template>
      </el-table-column>
      <el-table-column
        label="实际成交价"
        width="120"
        v-if="colOptions.tradingPrice"
      >
        <template slot-scope="scope">
          <span class="primary_text">{{ scope.row.tradingPrice }} 元/吨</span>
        </template>
      </el-table-column>

      <el-table-column
        label="实际总金额"
        width="120"
        v-if="colOptions.realAmount"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.realAmount" class="primary_text">
            ￥ {{ scope.row.realAmount }} 元
          </span>
          <span v-else>/</span>
        </template>
      </el-table-column>

      <el-table-column label="主车号" width="100" v-if="colOptions.plateNumber">
        <template slot-scope="scope">
          <span>{{ scope.row.plateNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="挂车号"
        width="100"
        v-if="colOptions.carriageNumber"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.carriageNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column label="驾驶员" width="100" v-if="colOptions.driverName">
        <template slot-scope="scope">
          <span>{{ scope.row.driverName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="驾驶员电话"
        width="110"
        v-if="colOptions.driverMobile"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.driverMobile }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        width="160"
        v-if="colOptions.createTime"
        prop="createTime"
        sortable
      >
        <template slot-scope="scope">
          {{ scope.row.createTime }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope"> 
            <div class="btn-box" style="display: flex;justify-content: center;">
                <el-button
                size="mini"
                type="info"
                v-can="['btn:project_approval']"
                style="padding:5px;margin-bottom: 5px;"
                @click="exm_ok(scope.row)"
                v-show="
                    scope.row.arrears == 1 || scope.row.status == 0
                "
                >审核</el-button
                >
                <el-button
                size="mini"
                type="info"
                class="btnBh"
                    style="padding:5px;margin-bottom: 5px;"
                v-if="has_permission('view:plan_detail')"
                :disabled="is_post"
                @click="goToDetail(scope.row)"
                plain
                >计划单详情</el-button
                >
            </div>
        </template>
      </el-table-column>
    </el-table>
  
      <footer>
        <el-pagination
            style="float: left;position: relative;top: 10px;"
            @current-change="pageChange"
            @size-change="handleSizeChange"
            :current-page.sync="selectForm.pageNum"
            :page-size="selectForm.pageSize"
            :page-sizes="selectForm.pageSizes"
            :hide-on-single-page="false"
            layout="sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </footer>
    <el-dialog title="批量修改时间" :visible.sync="isShowEditDate" width="500px">
      <el-select v-model="editPlanDate" placeholder="请选择计划日期" style="width:100%">
        <el-option
            v-for="item in dates"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowEditDate = false">取 消</el-button>
        <el-button type="primary" @click="updatePlanDate">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import request from "@/utils/request";
import can from "@/directive/can/index.js";
import { parseTime } from "@/utils";
import defaultSetting from "@/settings";
import { getToken } from "@/utils/auth";
import pdf from "vue-pdf";
import { mapGetters } from "vuex";
// import { forEach } from 'mock/user';

export default {
  name: "order_query",
  computed: {
    ...mapGetters(["permissions"]),
  },
  directives: { can },
  data() {
    let validate_cut_price = (rule, value, callback) => {
      if (parseFloat(value) >= parseFloat(this.priceForm.realPrice)) {
        callback(new Error("优惠不能大于价格!"));
      } else {
        callback();
      }
    };
    return {
      is_ok: false,
      is_loading: false,
      is_post: false,
      isShowEditDate: false,
      editPlanDate:"",
      data: [],
      selectForm: {
        planDate: [],
        orderSn: "",
        comId: "",
        plateNumber: "",
        driverName: "",
        driverMobile: "",
        newStatus: "",
        status:[],
        pageNum: 1,
        pageSize: 20,
        pageSizes:[10, 20, 50, 100, 200]
      },

      total: 0,
      is_select: false,
      componys: [],
      statusOptions: [
        { value: -1, label: "全部" },
        { value: 0, label: "待审核" },
        { value: 10, label: "已审核" },
        { value: 15, label: "已打卡" },
        { value: 16, label: "已登记" },
        { value: 21, label: "入场安检" },
        { value: 23, label: "一次过磅" },
        { value: 24, label: "已充装" },
        { value: 26, label: "出厂安检" },
        // { value: 27, label: "二次过磅" },
      ],
      colConfigDialog: false,
      colOptions: {
        orderSn: true,
        comName: true,
        goodsName: true,
        planDate: true,
        status: true,
        remark: true,
        tradingPrice: true,
        cutPrice: false,
        realPrice: true,
        planWeight: true,
        realWeight: true,
        otherFee: true,
        plateNumber: true,
        carriageNumber: true,
        driverName: true,
        driverMobile: true,
        tareWeight: true,
        grossWeight: true,
        netWeight: true,
        createTime: true,
        processOneTime: true,
        processTwoTime: true,
        realAmount: false,
      },

      defaultProps: {
        children: "children",
        label: "label",
      },
      tableMinHeight: 700,
      showtable: false,
      tree_set: null,
      tree_arr: [],
      selecte_arr: [],
      active_item: null,

      show_files_dialog: false,
      preview_dialog: false,
      numPages: null,
      preview_file: null,
      is_show_pdf: false,

    // 迁移
      currentPlanNum:'',//当前计划
      pendApprovedPlanNum:'',//待审批计划
      approvedPlanNum:'',//已审批计划
      changePlanNum:'',//变更计划
      fileUploadBtnText: "导入计划单",
      activeAudit: false,
      uploadDialog:false,
      statuType:[
          {lb:'待审核',vl:0},
          {lb:'已审核',vl:10},
          {lb:'已打卡',vl:15},
          {lb:'入厂安检',vl:21},
          {lb:'一次过磅',vl:23},
          {lb:'已充装',vl:24},
          {lb:'出厂安检',vl:26},
      ],
      dates:[],
      activeName: "first",
      itemCheck: [], //
      is_price: false,
      edit_dialog: false,
      edit_price_dialog: false,
      exportCurrDialog:false,
      limitNum: 1,
      priceForm: {
        ids: [],
        realPrice: "",
        saleCutPrice: "",
      },
      uploadForm: {
        planDate: "",
      },
      uploadLoading:false,
      priceRules: {
        realPrice: [
          { required: true, message: "请输入实际价格", trigger: "blur" },
          {
            pattern: /^([0-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,
            message: "请输入一个数字,最多保留2位小数",
            trigger: "blur",
          },
        ],
        saleCutPrice: [
          { required: true, message: "请输入销售优惠", trigger: "blur" },
          {
            pattern: /^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2}|0)$/,
            message: "请输入一个数字,最多保留2位小数",
            trigger: "blur",
          },
          { validator: validate_cut_price, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    //导出当前计划
    async exportCurrSubmit(){
      if(this.uploadForm.planDate==''){
        this.$message.error("请先选择计划日期！");
      }else{
          try{
              let res = await fetch(this.baseUrl+"/order/export?planDate="+this.uploadForm.planDate,{
                  method:"GET",
                  headers:{
                      "Authorization":getToken(),
                      "Content-Type":"application/json;charset=utf-8"
                  },
              });
              let blob = await res.blob();
              const a= document.createElement("a")
              a.href = URL.createObjectURL(blob)
              a.download = "计划单"+this.uploadForm.planDate+".xls"
              a.click()
              URL.revokeObjectURL(a.href)
              this.$message.success("导出成功!");
              this.exportCurrDialog = false;
          }catch(err){
          }finally {
          }
      }
    },
    downloadCurrExcel(){
      this.exportCurrDialog = true;
    },
    beforeAvatarUploadPDF(){
      this.$refs.upload.clearFiles();
    },
    //已变更计划变色
    changebg({row}) {
      let styleJson={};
      if(row.clientEditFlag==1){// 变颜色的条件
        styleJson={"background-color": "#D1ECCF"}
      }
      return styleJson;
    },
    clickSubmit(){
      if(this.uploadForm.planDate==''){
        this.$message.error("请先选择计划日期！");
      }else{
         this.$refs['upload'].$refs['upload-inner'].handleClick()
      }
    },
    //销售审核开关
    switch_exm(e) {
      this.activeAudit = e;
      request.post("/web_config/switch_exm", { switchExm: e }).then((res) => {
        //哈哈，朕也不知道是干嘛！！！！
        //先皇告诉你这是提交手动审核开关状态的
      });
    },
    //提交价格修改
    submitPriceChange() {
      this.$refs["priceForm"].validate((valid) => {
        if (!valid) return false;
        this.is_post = true;
        request
          .post("order/exe", {
            changeAmount: this.priceForm.realPrice,
            orderIds: this.itemCheck,
          })
          .then((res) => {
            this.$message.success("调价操作成功!");
            this.is_post = false;
            this.is_price = false;
            this.getData();
            this.itemCheck.length=0;
            this.edit_price_dialog = false;
            this.$refs["priceForm"].resetFields();
            this.priceForm = {
              ids: [],
              realPrice: "",
              saleCutPrice: "",
            };
          })
          .catch((err) => {
            this.is_post = false;
          });
      });
    },
    auditSwitch() {
      request.post("web_config/get/SELLER_EXM").then((res) => {
        if (res.code == 200) {
          if (res.data.value == "NOT_EXAMINE") {
            this.activeAudit = false;
          } else {
            this.activeAudit = true;
          }
        }
      });
    },
    //审核及其shenpi
    exm_ok(item) {
      this.$confirm("此操作将允许该审批单通过, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.is_post = true;
        request
          .post("order/seller/exm", { orderId: item.id, approved: true })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success("操作成功!");
              this.getData();
              this.purchaseList();
              this.is_post = false;
            }
          })
          .catch((err) => {
            this.is_post = false;
          });
      });
    },
    //批量调价
    changePrice() {
      if(this.itemCheck.length>0){
        this.is_price = true;
      }else{
        this.$message.error("请选择相对应的计划！");
      }
    },
    handleSizeChange(val){
        this.selectForm.pageSize = val;
        this.getData();
    },
    goToAdd() {
      this.$router.push({ name: "plan_add" });
    },
    //当前计划
    currentPlanBtn() {
      this.selectForm.newStatus='';
      this.getData();
      
    },
    // 待审批计划
    pendApprovedPlanBtn() {
      this.selectForm.newStatus=0;
      this.getData();
  
    },
    // 已审批计划
    approvedPlanBtn() {
      this.selectForm.newStatus=1;
      this.getData();
      
    },
    // 变更计划
    changePlanBtn() {
      this.selectForm.newStatus=2;
      this.getData();
      
    },
    //当前计划4个统计信息
    getCurrCount(){
        request.post('order/curr_count',{type:0}).then(res=>{
            if(res.code==200){
              this.currentPlanNum=res.data.curr;//当前计划
              this.pendApprovedPlanNum=res.data.noExam;//待审批计划
              this.approvedPlanNum=res.data.examined;//已审批计划
              this.changePlanNum=res.data.modified;//变更计划
            }
        })
    },
    //表格选择计划单
    selectHandle(selection,row){
        if (!this.itemCheck.includes(row.id)) {
          this.itemCheck.push(row.id);
        }else{
          // filter保留符合条件的所有元素。
          this.itemCheck = this.itemCheck.filter(item => item!=row.id)
        }
    },
    // 下载计划单模板
    async downloadExcel() {
      window.location.href ="https://jbxy-lng-bucket.oss-cn-beijing.aliyuncs.com/excel_template/template.xls"
    },
    // 导入
    fileUploadSuccess() {
      this.enabledUploadBtn = true;
      this.uploadBtnIcon = "el-icon-upload2";
      this.fileUploadBtnText = "导入计划单";
      this.$message.success("数据导入成功！");
    },
    fileUploadError() {
      this.enabledUploadBtn = true;
      this.uploadBtnIcon = "el-icon-upload2";
      this.fileUploadBtnText = "导入计划单";
    },
    //上传excel文件-请求接口
    uploadFile(item) {
      this.uploadLoading=true;
      let formData = new FormData();
      formData.append("excel", item.file);
      formData.append("planDate",this.uploadForm.planDate);
      request.post("order/import", formData).then((res) => {
        if (res.code == 200) {
          this.getData(true);
          this.getCurrCount();
          this.uploadLoading=false;
          this.uploadDialog=false;
          this.uploadForm.planDate='';
          this.$message.success("数据导入成功！");
        } else {
          this.uploadLoading=false;
          this.uploadDialog=false;
          this.uploadForm.planDate='';
          this.$message.error("数据导入失败！");
        }
      });
    },
    clickUpload(){
      this.uploadDialog=true;
    },
    // 批量审批
    batchApproval() {
      if(this.itemCheck.length==0){
        this.$message.error("请选择相对应的计划！");
      }else{
        this.is_batch_pass = true;
        request.post("order/seller/batch_exm",{approved: true,opinion: "",orderIds: this.itemCheck}).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.is_batch_pass = false;
            this.getData(true);
            this.purchaseList();
            this.itemCheck=[];
          }else{
            this.$message.error(res.msg);
          }
        });
      }
    },
    // 批量驳回
    batchRejected() {
      if(this.itemCheck.length==0){
        this.$message.error("请选择相对应的计划！");
      }else{
          this.is_batch_reject = true;
        request.post("order/seller/batch_exm",{approved: false,opinion: "",orderIds: this.itemCheck}).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.is_batch_reject = false;
            this.getData(true);
            this.purchaseList();
            this.itemCheck=[];
          }else{
            this.$message.error(res.msg);
          }
        });
      }
    },

    showEditPlanDate(){
      if(this.itemCheck.length==0){
        this.$message.error("请选择相对应的计划！");
      }else{
        this.isShowEditDate = true;
        this.editPlanDate = "";
        
      }
    },
    
    updatePlanDate(){
      request.post("order/com_edit_planDate",{ planDate: this.editPlanDate, orderIds: this.itemCheck}).then((res) => {
        if (res.code == 200) {
          this.$message.success("计划日期修改成功");
          this.isShowEditDate = false;
          this.getData(true);
          this.purchaseList();
          this.itemCheck=[];
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    
    resetSelect() {
      this.selectForm = {
        orderSn: "",
        comId: "",
        planDate: null,
        plateNumber: "",
        driverName: "",
        driverMobile: "",
        status: [],
        pageNum: 1,
        pageSize: 20,

      };
      this.$refs["selectForm"].resetFields();
      this.getData();
    },
    selectSubmit() {
      this.getData();
    },
    getData(is_init = false) {
      if (!is_init) {
        this.is_loading = true;
        this.is_post = true;
      }
      request
        .post("order/query", this.selectForm)
        .then((res) => {
          this.data = res.data.list;
          this.total = res.data.total;
          if (!is_init) {
            this.is_loading = false;
            this.is_post = false;
          } else {
            this.is_ok = true;
            this.showtable = true;
          }
        })
        .catch((err) => {
          if (!is_init) {
            this.is_loading = false;
            this.is_post = false;
          } else {
            this.is_ok = true;
            this.showtable = true;
          }
        });
    },
    // statusChange(val) {
    //   if (val.includes(-1) || val.value == -1) {
    //     this.selectForm.status = [-1];
    //     this.$refs["selectForm_status"].blur();
    //   }
    // },
    handleSelectionChange(arr) {
      this.selecte_arr = arr;
      this.itemCheck = [];
      arr.forEach(item =>{
        this.itemCheck.push(item.id);
      })
    },
    //分页改变
    pageChange(page) {
      this.selectForm.pageNum = page;
      this.itemCheck = []
      this.getData();
    },

    changeCom(e) {
      this.selectForm.comId = e;
      this.getData();
    },

    goToDetail(item) {
      if (!this.has_permission("view:plan_detail")) {
        return false;
      }
      this.$router.push({ name: "plan_detail", params: { id: item.id } });
    },
    
    has_permission(permission) {
      return this.permissions.includes(permission);
    },

    parseStatus(num) {
      switch (num) {
        case 0:
          return "待审核";
        case 10:
          return "已审核"; //待打卡
        case 15:
          return "已打卡"; //待登记
        case 16:
          return "已登记"; //待入场安检
        case 21:
          return "入厂安检"; //待一次过磅
        case 23:
          return "一次过磅"; //待充装
        case 24:
          return "已充装"; //待出厂安检
        case 26:
          return "出厂安检"; //待二次过磅
        case 27:
          return "二次过磅"; //待打印
        case 30:
          return "已完成"; //已打印
        case 90:
          return "客户取消";
        case 91:
          return "液厂取消";
        case 92:
          return "已过期";
      }
    },
    statusType(n) {
      if (n < 10) {
        return "warning";
      } else if (n >= 10 && n < 20) {
        return "primary";
      } else if (n >= 20 && n <= 30) {
        return "success";
      } else {
        return "danger";
      }
    },

    tableRowClassName({ row, rowIndex }) {
      if (row.status == 30) {
        return "success-row";
      } else if (row.status == 90) {
        return "warning-row";
      } else {
        return "danger-row";
      }
    },
    getNumPages(url) {
      return new Promise((resolve, reject) => {
        let loadingTask = pdf.createLoadingTask(url);
        loadingTask.promise
          .then((pdf) => {
            this.numPages = pdf.numPages;
            resolve();
          })
          .catch((err) => {
            console.error("pdf 加载失败", err);
            this.is_show_pdf = false;
            reject(err);
          });
      });
    },
    async preview(file) {
      if (file.fileType == "pdf") {
        //pdf
        this.preview_file = file;
        this.preview_dialog = true;
        this.is_show_pdf = true;
        await this.getNumPages(file.url);
        this.is_show_pdf = false;
      } else {
        this.preview_file = file;
        this.preview_dialog = true;
      }
    },
    getCompany() {
      request
        .get("company/option")
        .then((res) => {
          this.componys = res.data;
        })
        .catch((err) => {});
    },
  },
  created() {
    let time = new Date();
    this.dates.push(parseTime(time,"{y}-{m}-{d}"));
    time = time.getTime()+86400000;
    this.dates.push(parseTime(time,"{y}-{m}-{d}"));
  },
  mounted() {
    this.getData(true);
    this.auditSwitch();
    this.getCompany();
    this.getCurrCount();
    this.baseUrl = process.env.VUE_APP_BASE_API + "/" + defaultSetting.api_version;
  },
};
</script>

<style scoped>
</style>
